import { BimEntityProperties } from 'Data/interfaces/BimViewer/IBimViewerPort';
import {
  IAttributesCategories,
  ICategoryProperties,
  IProperties,
} from 'Data/interfaces/FederatedViewer/IProperties';

// O painel de propriedades do federado foi escrito para o formato da Autodesk
// (`IProperties`: categorias com pares nome/valor). O motor IFC devolve outra
// forma — atributos soltos na raiz da entidade, mais property sets e quantity
// sets. Traduzir aqui mantém um painel só para os dois motores, em vez de dois
// componentes com a mesma aparência.
//
// `dbId` recebe o `expressId`: os dois são o identificador do elemento dentro do
// modelo, e é assim que o painel titula a seleção.

const IFC_ATTRIBUTE_LABELS: [keyof BimEntityProperties, string][] = [
  ['name', 'Nome'],
  ['ifcType', 'Tipo IFC'],
  ['predefinedType', 'Tipo predefinido'],
  ['objectType', 'Tipo do objeto'],
  ['tag', 'Tag'],
  ['description', 'Descrição'],
  ['globalId', 'GlobalId'],
];

const toAttributes = (entity: BimEntityProperties): IAttributesCategories[] => (
  IFC_ATTRIBUTE_LABELS
    .filter(([key]) => {
      const value = entity[key];
      return value !== undefined && value !== null && value !== '';
    })
    .map(([key, displayName]) => ({
      displayName,
      displayValue: String(entity[key]),
      units: null,
    }))
);

export const bimEntityToProperties = (
  entity: BimEntityProperties | null,
): IProperties | null => {
  if (!entity) {
    return null;
  }

  const categories: ICategoryProperties[] = [];

  const attributes = toAttributes(entity);
  if (attributes.length > 0) {
    categories.push({ categoryName: 'Identificação', categoryProperties: attributes });
  }

  // Psets e Qtos viram uma categoria cada, com o nome que veio do arquivo — é o
  // agrupamento que o usuário de IFC espera ver.
  for (const set of [...entity.propertySets, ...entity.quantitySets]) {
    if (set.properties.length === 0) { continue; }
    categories.push({
      categoryName: set.name,
      categoryProperties: set.properties.map((property) => ({
        displayName: property.name,
        displayValue: property.value,
        units: null,
      })),
    });
  }

  return {
    dbId: entity.expressId,
    name: entity.name || entity.ifcType,
    properties: categories,
  };
};
